/* eslint-disable no-unused-vars */
import { UserCheck, X } from 'lucide-react';
import React from 'react';
import { CopyButton } from '../CopyButton';
import type { UseActionDialogReturn } from '../../hooks/useActionDialog';

type InviteRevealDialogProps = {
  actionDialogReturn: UseActionDialogReturn;
  onNavigate: (path: string, opts?: { replace?: boolean }) => void;
};

function InviteRevealDialog({ actionDialogReturn, onNavigate: _onNavigate }: InviteRevealDialogProps) {
  const {
    actionDialog,
    dialogBusy,
    setActionDialog,
  } = actionDialogReturn;

  if (!actionDialog || actionDialog.kind !== 'invite-reveal') return null;

  const close = () => { if (!dialogBusy) setActionDialog(null); };

  return (
    <div className="dialogOverlay" role="presentation" onClick={close}>
      <div className="dialogPanel" onClick={(e) => e.stopPropagation()}>
        <div className="dialogHeader">
          <div>
            <div className="panelKicker">Members</div>
            <h3>Invite link ready</h3>
            <p>Share this link with your collaborator. It expires in 7 days and can only be used once.</p>
          </div>
          <button type="button" className="iconButton" onClick={close} aria-label="Close dialog">
            <X size={16} />
          </button>
        </div>
        <div className="settingsForm">
          <div className="keyRevealEnvHint">
            <span className="keyRevealEnvHintLabel">
              <UserCheck size={12} style={{ display: 'inline', marginRight: 4 }} />
              {actionDialog.role} invite{actionDialog.emailHint ? ` · ${actionDialog.emailHint}` : ''}
            </span>
            <div className="keyRevealEnvRow">
              <code className="keyRevealEnvCode" style={{ fontSize: 11, wordBreak: 'break-all', overflowWrap: 'break-word', flex: 1, minWidth: 0 }}>
                {actionDialog.inviteUrl}
              </code>
              <CopyButton value={actionDialog.inviteUrl} label="Copy invite link" />
            </div>
          </div>
          <p className="fieldHint" style={{ color: 'var(--amber)', marginTop: 8 }}>
            This link will not be shown again after closing this dialog.
          </p>
        </div>
        <div className="dialogActions">
          <button type="button" className="primaryButton" onClick={close}>Done</button>
        </div>
      </div>
    </div>
  );
}

export { InviteRevealDialog };
